<template>
  <h2>What Is a Web Proxy?</h2>
  <p>
    A web proxy allows you to browse the web anonymously and unblock your favorite websites without
    installing software, like a VPN. Our web proxy is free and supports the most popular websites,
    such as YouTube, Google, Facebook, Twitter, and adult entertainment websites. All your traffic
    is encrypted while browsing to make sure you stay anonymous.&nbsp;
  </p>
  <h2>How Does Web Proxy Work?</h2>
  <p>
    A Web Proxy has its own IP address, which acts as the intermediary between the user and the
    internet. Once the user requests information online, the request is routed via a web proxy, the
    web proxy retrieves the information from the targeted website, then sends it to the user. This
    way the user's local IP address is masked.
  </p>
</template>
